import api from './api'

export const device = {
  custDevPageList: (params) => {
    return api.post(`/CloudParkAPI/Device/custDevPageList`, params)
  },
  custParkMonitorList: (params) => {
    return api.post(`/CloudParkAPI/Device/CustParkMonitorList`, params)
  },
  custDevSetList: (params) => {
    return api.post(`/CloudParkAPI/Device/custDevSetList`, params)
  },
  custDevLogPageList: (params) => {
    return api.post(`/CloudParkAPI/Device/CustDevLogPageList`, params)
  },
  custDevLogList: (params) => {
    return api.post(`/CloudParkAPI/Device/CustDevLogList`, params)
  },
  custDevLogInfo: (id) => {
    return api.get(`/CloudParkAPI/Device/CustDevLogInfo/${id}`)
  },
  custDevAlarmPageList: (params) => {
    return api.post(`/CloudParkAPI/Device/CustDevAlarmPageList`, params)
  },
  channelLogList: (params) => {
    return api.post(`/CloudParkAPI/Device/ChannelLogList`, params)
  },
  errorLogPageList: (params) => {
    return api.post(`/CloudParkAPI/Device/ErrorLogPageList`, params)
  },
  cloudPageList: (params) => {
    return api.post(`/CloudParkAPI/Device/CloudPageList`, params)
  },
  gateOperationLogList: (params) => {
    return api.post(`/CloudParkAPI/Device/GateOperationLogList`, params)
  },
  devAccLogPageList: (params) => {
    return api.post(`/CloudParkAPI/Device/DevAccLogPageList`, params)
  },
  devAccLogDownLoad: (params) => {
    return api.post(`/CloudParkAPI/Device/DevAccLogDownLoad`, params)
  },
  shra2019PageList: (params) => {
    return api.post(`/CloudParkAPI/Device/Shra2019PageList`, params)
  },
  shra2019LogPageList: (params) => {
    return api.post(`/CloudParkAPI/Device/shra2019LogPageList`, params)
  },
  geomagneticPageList: (params) => {
    return api.post(`/CloudParkAPI/Device/GeomagneticPageList`, params)
  },
  geomagneticInfo: (params) => {
    return api.post(`/CloudParkAPI/Device/GeomagneticInfo`, params)
  },
  editGeomagnetic: (params) => {
    return api.post(`/CloudParkAPI/Device/EditGeomagnetic`, params)
  },
  delGeomagnetic: (params) => {
    return api.post(`/CloudParkAPI/Device/DelGeomagnetic`, params)
  },
  geomagneticBusPageList: (params) => {
    return api.post(`/CloudParkAPI/Device/GeomagneticBusPageList`, params)
  },
  getDeviceNameList: (params) => {
    return api.get(`/CloudParkAPI/Device/GetDeviceNameList`, params)
  },
  shra2019ParkList: (params) => {
    return api.post(`/CloudParkAPI/Device/Shra2019ParkList`, params)
  },
  shra2019DevList: (params) => {
    return api.post(`/CloudParkAPI/Device/Shra2019DevList`, params)
  },
  getLogFolderAndFiles: (params) => {
    return api.post(`/CloudParkAPI/Device/GetLogFolderAndFiles`, params)
  },
  downloadFile: (params) => {
    return api.download(`/CloudParkAPI/Device/DownloadFile`, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/device.js